<template>
    <div class="prose">
        <h1>Terms</h1>
    </div>
</template>
<script setup lang="ts"></script>
